import { useSyncExternalStore } from 'react';

/**
 * Shared in-memory state for the "payer paid the patient" case (D197, H1–H3).
 * Posting calls `markPaidToPatientPosted` when a person posts it; Claims and
 * Insurance A/R read `isPaidToPatientPosted` to close the claim / drop it from
 * the "The payer pays the patient" group.
 */
const posted = new Set<string>();
let version = 0;
const listeners = new Set<() => void>();
function bump() { version++; listeners.forEach((l) => { l(); }); }

export function usePaidToPatientVersion(): number {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => version,
    () => version,
  );
}
/** Key is the claim id, e.g. 'CLM-28820' (Iris Calder). */
export function markPaidToPatientPosted(claimId: string): void { posted.add(claimId); bump(); }
export function isPaidToPatientPosted(claimId: string): boolean { return posted.has(claimId); }
export function resetPaidToPatient(): void { posted.clear(); bump(); }

/** The 6 mock claims where the payer pays the patient (H3 §3). All Dr. Marcus Lee. */
export interface PaysPatientClaim {
  claimId: string;
  patient: string;
  payer: string;
  sent: string;
  sentIso: string;
  billed: number;
}
export const PAYS_PATIENT_CLAIMS: PaysPatientClaim[] = [
  { claimId: 'CLM-28822', patient: 'Leo Marsh', payer: 'MetLife', sent: 'Oct 2', sentIso: '2026-10-02', billed: 1450 },
  { claimId: 'CLM-28820', patient: 'Iris Calder', payer: 'MetLife', sent: 'Sep 30', sentIso: '2026-09-30', billed: 1450 },
  { claimId: 'CLM-28818', patient: 'Ana Pruitt', payer: 'Guardian', sent: 'Sep 28', sentIso: '2026-09-28', billed: 1450 },
  { claimId: 'CLM-28812', patient: 'Cole Dawson', payer: 'MetLife', sent: 'Sep 22', sentIso: '2026-09-22', billed: 1180 },
  { claimId: 'CLM-28806', patient: 'Mae Fuller', payer: 'Guardian', sent: 'Sep 18', sentIso: '2026-09-18', billed: 1295 },
  { claimId: 'CLM-28798', patient: 'Ray Lindqvist', payer: 'Guardian', sent: 'Sep 10', sentIso: '2026-09-10', billed: 1295 },
];
